export const AuthConstants = {
  authTokenKey: 'access_token',
  authExpiryKey: 'access_expires',
  authUserId: 'user_id',
  reCaptchaUiKey: '6LerpLoZAAAAAK38bezTW4l0vF3zsBYN8CwJbpz-',
}
